import { Controller } from "@hotwired/stimulus"

// Civic Warmth replacement for Bootstrap's tabs (data-bs-toggle="tab").
// Panels pair with tab buttons by index. Active styling keys off
// aria-selected (use Tailwind's aria-selected: variants in the markup).
// Left/Right arrow keys move focus across tabs (roving tabindex) and
// activate the focused tab, per the WAI-ARIA tabs pattern.
//
//   <div data-controller="tabs">
//     <div role="tablist">
//       <button role="tab" aria-selected="true" data-tabs-target="tab" data-action="tabs#select">One</button>
//       <button role="tab" aria-selected="false" data-tabs-target="tab" data-action="tabs#select">Two</button>
//     </div>
//     <div role="tabpanel" data-tabs-target="panel">...</div>
//     <div role="tabpanel" data-tabs-target="panel" class="hidden">...</div>
//   </div>
export default class extends Controller {
  static targets = ["tab", "panel"]

  tabTargetConnected(tab) {
    tab.setAttribute("tabindex", tab.getAttribute("aria-selected") === "true" ? "0" : "-1")
    tab.addEventListener("keydown", this.#onKeydown)
  }

  tabTargetDisconnected(tab) {
    tab.removeEventListener("keydown", this.#onKeydown)
  }

  select(event) {
    this.#activate(this.tabTargets.indexOf(event.currentTarget))
  }

  #onKeydown = (event) => {
    if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return

    event.preventDefault()
    const delta = event.key === "ArrowRight" ? 1 : -1
    const count = this.tabTargets.length
    const index = (this.tabTargets.indexOf(event.currentTarget) + delta + count) % count
    this.tabTargets[index].focus()
    this.#activate(index)
  }

  #activate(index) {
    this.tabTargets.forEach((tab, i) => {
      const selected = i === index
      tab.setAttribute("aria-selected", selected.toString())
      tab.setAttribute("tabindex", selected ? "0" : "-1")
    })
    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("hidden", i !== index)
    })
  }
}
